import { render, staticRenderFns } from "./ReceiptTemplate.vue?vue&type=template&id=9f71e37c&scoped=true&lang=pug&"
import script from "./ReceiptTemplate.vue?vue&type=script&lang=js&"
export * from "./ReceiptTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptTemplate.vue?vue&type=style&index=0&id=9f71e37c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f71e37c",
  null
  
)

export default component.exports